const reEncodeUri = (str: string) => {
  try {
    return encodeURI(decodeURI(str))
  } catch (e) {
    return encodeURI(str)
  }
}

export const sanitize = (value?: string) => {
  return value && reEncodeUri(value)
}

export const sanitizeCollection = (
  collection: { key: string; group: string }[],
) => {
  return collection.map(x => ({
    group: reEncodeUri(x.group),
    facetKey: reEncodeUri(x.key),
  }))
}
